import EventCard from "../../../../src/components/home/eventCard";
import { withPrefix } from "gatsby";
import * as React from 'react';
export default {
  EventCard,
  withPrefix,
  React
};